import { render, staticRenderFns } from "./PageProperties.vue?vue&type=template&id=a9e4c3b4"
import script from "./PageProperties.vue?vue&type=script&lang=js"
export * from "./PageProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports